import React from "react";
import { storyblokEditable } from "@storyblok/react";

import { FeatureTablePanelModel } from "./FeatureTablePanelModel";
import FeatureTablePanelDesktop from "./FeatureTablePanelDesktop";
import FeatureTablePanelMobile from "./FeatureTablePanelMobile";

import "./FeatureTablePanel.css";

const FeatureTablePanel: React.FC<{ blok: FeatureTablePanelModel }> = ({
  blok,
}) => {
  if (!blok?.entity || blok.entity.length !== 1) {
    return null;
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="feature-table-panel"
      style={{
        backgroundColor: blok.media?.filename ? "" : blok.backgroundColor,
      }}
    >
      <FeatureTablePanelDesktop blok={blok}></FeatureTablePanelDesktop>
      <FeatureTablePanelMobile blok={blok}></FeatureTablePanelMobile>
    </div>
  );
};

export default FeatureTablePanel;
